import { render, staticRenderFns } from "./ChartUsersGender.vue?vue&type=template&id=24df1adc"
import script from "./ChartUsersGender.vue?vue&type=script&lang=js"
export * from "./ChartUsersGender.vue?vue&type=script&lang=js"
import style0 from "./ChartUsersGender.vue?vue&type=style&index=0&id=24df1adc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports